import icon from 'vue-svgicon';

icon.register({
    'regular/earth-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<circle pid="0" cx="12" cy="12" r="11.25" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" d="M7.079 15.75a1.5 1.5 0 0 0 1.455-1.864l-.75-3A1.5 1.5 0 0 0 6.329 9.75H.976a11.246 11.246 0 0 0 4.016 11.042L6 15.75zM20.985 5.25h-4.064a1.5 1.5 0 0 0-1.455 1.136l-.75 3a1.5 1.5 0 0 0 1.455 1.864h1.579l.791 4.75a1.5 1.5 0 0 0 1.48 1.253h1.925a11.2 11.2 0 0 0-.961-12z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
